import { useContext, useEffect, useState } from 'react'

import Button from '@atoms/Button'
import { StoreContext } from '@src/models/Store'
import { sleep } from '@src/models/Util'

import * as style from './style.module.sass'

const Toast = () => {
  const { entity, action } = useContext(StoreContext)
  const [show, setShow] = useState(false)
  const text = entity.toasts[0]

  const remove = async () => {
    setShow(false)
    await sleep(500)

    action.removeToasts()
  }

  useEffect(() => {
    if (entity.toasts.length === 0) {
      return
    }

    setShow(true)
  }, [entity.toasts])

  return (
    <div className={style.toastContainer} data-show={show}>
      <div className={style.toast}>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path
            d="M12 7V13"
            stroke="#EB5757"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12 17.0091L12.01 16.998"
            stroke="#EB5757"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
            stroke="#EB5757"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <div
          className={style.text}
          dangerouslySetInnerHTML={{ __html: text }}
        />
        <Button design="white" onClick={remove}>
          OK
        </Button>
      </div>
    </div>
  )
}

export default Toast
